// Category integers: 0 - DEALS, 1 - POSTS_AND_UPDATES, 2 - DOCUMENTS, 3 - OPERATIONAL, 4 - MARKETING
// Subcategory integers:
//   DEALS:             0 - DEAL_INVITES, 1 - DEAL_CLOSES, 2 - ALLOCATION_UPDATES, 3 - DEAL_UPDATES
//   POSTS_AND_UPDATES: 4 - PORTFOLIO_COMPANY_POSTS, 5 - ANGELLIST_COMMENTARY, 16 - PORTFOLIO_UPDATE_REQUESTS
//   DOCUMENTS:         6 - STATEMENTS, 7 - CONTRIBUTIONS, 8 - DISTRIBUTIONS
//   OPERATIONAL:       9 - BANK_TRANSFERS, 10 - KYC, 11 - TAX_FILINGS, 12 - CONSENT_REQUESTS
//   MARKETING:         13 - PRODUCT_UPDATES, 14 - EVENTS, 15 - RESEARCH

export const CATEGORY_CONFIG: Record<number, { label: string; description: string }> = {
  0: { label: 'Deals', description: 'New invites, deal closes, allocation updates' },
  1: {
    label: 'Posts & updates',
    description:
      'Portfolio company posts, portfolio update requests, and AngelList India commentary',
  },
  2: { label: 'Documents', description: 'New statements, contributions, distributions' },
  3: { label: 'Operational', description: 'Bank transfers, KYC, tax filings, consent requests' },
  4: { label: 'Marketing', description: 'Product updates, events, research' },
};

export const SUBCATEGORY_LABELS: Record<number, string> = {
  0: 'Deal invites',
  1: 'Deal closes',
  2: 'Allocation updates',
  3: 'Deal updates',
  4: 'Portfolio company posts',
  5: 'AngelList India commentary',
  16: 'Portfolio update requests',
  6: 'Statements',
  7: 'Contributions',
  8: 'Distributions',
  9: 'Bank transfers',
  10: 'KYC',
  11: 'Tax filings',
  12: 'Consent requests',
  13: 'Product updates',
  14: 'Events',
  15: 'Research',
};

export const CATEGORY_SUBCATEGORIES: Record<number, number[]> = {
  0: [0, 1, 2, 3],
  1: [4, 5, 16],
  2: [6, 7, 8],
  3: [9, 10, 11, 12],
  4: [13, 14, 15],
};

export type Channel = 'emailEnabled' | 'smsEnabled' | 'pushEnabled' | 'whatsappEnabled';

export const CHANNELS: { key: Channel; label: string; beta?: boolean }[] = [
  { key: 'emailEnabled', label: 'Email' },
  { key: 'smsEnabled', label: 'SMS', beta: true },
  { key: 'pushEnabled', label: 'Push', beta: true },
  { key: 'whatsappEnabled', label: 'WhatsApp' },
];
